module.exports = __webpack_public_path__ + "static/media/palette-grid.5ef93019.png";